import Lohi from "./lohi.jpeg"
import Deshmukh from "./Deshmukh.jpeg"
import Principal from "./principalsir.jpg"
import Metkar from "./Rmetkar.jpeg"
import Sumanmam from "./Sumanmam.jpg"
//notable speakers
const users = [
  // {
    
  //   name: 'Dr.Lalit Kumar (Convener),',
  //   img : Deshmukh,
  //   detail : 'IILM University, Greater Noida'
  // },
  
  // {
  //   name: ' Dr. Deependra Rastogi (Convener)',
  //   img:  Metkar,
  //   detail :'IILM University Greater Noida'
  // },
  {
    name: ' Mr. Shantanu Bindewari (Organizing Secretary)',
    img: Lohi,
    detail :"IILM University Greater Noida, UP"
  },
  {
    name: ' Dr. Sumit Singh Dhanda (Organizing Secretary)',
    img: Principal,
    detail :'IILM University Greater Noida, UP'
  },
  {
    name: ' Ms. Suman Avdhesh Yadav (Organizing Secretary)',
    img: Sumanmam,
    detail :'IILM University Greater Noida, UP'
  },
 
]
export default users